<!--
  crud asignar url de la api URL="url de la api" titulo="un titulo para la pestaña de la pagina" [dato]="variable que contiene el formulario]
-->
<app-formulario #ctrl URL="pago-publico" titulo="Pagos publicos" [dato]="dato"></app-formulario>

<!-- Menu principal " -->
<app-sistema-menu></app-sistema-menu>

<form name="form" novalidate [formGroup]="dato">
  <div class="contenedor columns " style=" overflow-y:auto; overflow-x: hidden;" [style.height.px]="tamano - 50">
    <!-- apartado de movimientos_articulos -->
    <div class="column" style="padding:0em; ">
      <div style="background: #FFF; border-radius: 1em; ">
        <section class="hero is-primary">
          <div class="hero-body">
            <nav class="level ">
              <!-- Left side -->
              <div class="level-left ">
                <div class="level-item">
                  <p class="title">
                    <span *ngIf="!ctrl.cargando || !cargando" class="icon is-medium">
                      <i class="icon-edit-1"></i>
                    </span>
                    Registrar pagos sin referencias bancarias
                  </p>
                </div>
              </div>

            </nav>
          </div>
        </section>
        <div class="is-fullwidth has-text-centered" *ngIf="cargando">
          <br />
          <span class="tag is-primary is-large ">
            <span class="icon"> <i class="icon-worldwide fa-spin"></i> </span>
            &nbsp; <span>Cargando...</span>
          </span>
        </div>
        <section style="padding: 1rem !important; overflow:auto; height: 86.5vh;" >
          <div class="notification is-warning" *ngIf="
              !caja_abierta &&
              ctrl.configuracion.sucursal.notificar_caja_cerrada
            ">
            ¡No se ha detectado ninguna caja abierta!
            <strong>Puede realizar el pago</strong>, Pero se recomienda que se
            habra la caja
            <a class="button is-small" routerLink="../../caja-operacion/nuevo">Abrir una caja</a>
          </div>
          <div class="notification is-danger" *ngIf="error_venta">
            ¡No se completo el pago! <strong>Intente de nuevo</strong>, Si no
            contacte con soporte
          </div>
          <div class="notification is-success" *ngIf="venta_ok">
            Pago realizado con exito <strong>Puede seguir agrenado más</strong>
          </div>
          <div class="notification is-black" *ngIf="sin_resultado != ''">
            ¡Mesaje del servidor! <strong>{{ sin_resultado }}</strong>
          </div>

          <div class="box" >
            <article class="media">
              <div class="media-content">
                <div class="content">
                  <div class="columns">
                    <div class="column is-6">
                      <div class="field">
                        <label class="label">Banco:</label>
                        <div class="control has-icons-left has-icons-right">
                          <div class="select">
                            <select class="select" formControlName="bancos_id" (change)="ctrl.catalogoDependiente('cuenta-bancaria', 'cuentas_bancarias', ctrl.dato.controls.bancos_id.value);">
                              <option value="">Seleccione</option>
                              <option *ngFor="let val of ctrl.bancos" value="{{val.id}}">{{val.nombre}}</option>
                            </select>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="column is-6">
                      <div class="field">
                        <label class="label">Cuenta:</label>
                        <div class="control has-icons-left has-icons-right">
                          <div class="select">
                            <select class="select" formControlName="cuentas_bancarias_id">
                              <option>Seleccione</option>
                              <option *ngFor="let item of ctrl.cuentas_bancarias" value="{{item.id}}">Clabe: {{item.clabe}} - No. Cuenta: {{item.no_cuenta}}</option>
                            </select>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="columns">
                    <div class="column is-3">
                      <div class="field">
                        <label class="label">Fehca:</label>
                        <p class="control has-icons-left has-icons-right">
                          <input class="input" autofocus type="date" [ngClass]="{'is-danger': ctrl.dato.get('fecha').hasError('required') }"
                            placeholder="Nombre" formControlName="fecha">
                          <span class="icon is-small is-right" *ngIf="ctrl.dato.get('fecha').hasError('required') ">
                            <i class="fa fa-warning"></i>
                          </span>
                          <span class="help is-danger" *ngIf="ctrl.dato.get('fecha').hasError('required') ">Este campo es requerido.</span>
                        </p>
                      </div>
                    </div>

                    <div class="column is-3">
                      <div class="field">
                        <label class="label">Hora:</label>
                        <p class="control has-icons-left has-icons-right">
                          <input class="input" autofocus type="time" [ngClass]="{'is-danger': ctrl.dato.get('hora').hasError('required') }"
                            placeholder="Nombre" formControlName="hora">
                          <span class="icon is-small is-right" *ngIf="ctrl.dato.get('hora').hasError('required') ">
                            <i class="fa fa-warning"></i>
                          </span>
                          <span class="help is-danger" *ngIf="ctrl.dato.get('hora').hasError('required') ">Este campo es requerido.</span>
                        </p>
                      </div>
                    </div>

                    <div class="column is-6">
                      <div class="field">
                        <label class="label">Establecimiento donde se realizó el pago:</label>
                        <p class="control has-icons-left has-icons-right">
                          <input class="input" type="text" [ngClass]="{'is-danger': ctrl.dato.get('sucursal').hasError('required') }"
                            placeholder="Clave" formControlName="sucursal">
                          <span class="icon is-small is-right" *ngIf="ctrl.dato.get('sucursal').hasError('required') ">
                            <i class="fa fa-warning"></i>
                          </span>
                          <span class="help is-danger" *ngIf="ctrl.dato.get('sucursal').hasError('required') ">Este campo es requerido.</span>
                        </p>
                      </div>
                    </div>
                  </div>
                  <div class="columns">
                    <div class="column is-12">
                      <div class="field">
                        <label class="label">Observaciones:</label>
                        <p class="control has-icons-left has-icons-right">
                          <textarea class="textarea" autofocus type="text" placeholder="Observaciones" formControlName="observaciones"></textarea>

                        </p>
                      </div>
                    </div>
                  </div>

                  <div class="columns" *ngIf="ctrl.dato.get('personas_id').value">
                    <div class="column is-12">

                    </div>
                  </div>

                </div>
              </div>
            </article>
          </div>


        </section>
      </div>
    </div>

    <!-- datos del cliente y los importes -->
    <div class="column is-one-third " style="padding:0em; width: 32%; ">
      <div style="background: #FFF; border-radius: 1em; ">
        <section class="hero is-primary">
          <div class="hero-head">
            <nav class="level">
              <!-- Left side -->
              <div class="level-left">
                <div class="level-item">
                  <p class="title is-4" style=" padding-left: 10px; ">
                    <span *ngIf="ctrl.cargando || cargando" class="icon is-medium">
                      <i class="icon-worldwide fa-spin"></i>
                    </span>
                  </p>
                </div>
              </div>

              <!-- Right side -->
              <div class="level-right">

                <a class="navbar-item is-primary tooltip" (click)="ctrl.regresar()">
                  <span class="icon fa-2x"> <i class="icon-back"> </i> </span>
                  <span class="tooltiptext">Regresar</span>
                </a>

                <a class="navbar-item is-primary tooltip" (click)="ctrl.cargarDatos()" id="cargar_datos_actualizar"
                  *ngIf="tieneid">
                  <span class="icon fa-2x">
                    <i class="icon-worldwide"></i>
                  </span>
                  <span class="tooltiptext">Actualizar</span>
                </a>

                <a class="navbar-item is-primary tooltip" routerLink="{{url_nuevo}}" *ngIf="ctrl.id">
                  <span class="icon fa-2x"> <i class="icon-file"></i> </span>
                  <span class="tooltiptext">Nuevo</span>
                </a>

                <button class="navbar-item  tooltip" type="button" (click)="cargarEditarFactura(ctrl.facturacion); abrir_facturacion();" >
                  <span class="icon fa-2x has-text-info">
                    <i class="icon-invoice"> </i>
                  </span>
                  <span class="tooltiptext">Facturación</span>
                </button>

                <button class="navbar-item  tooltip" type="button" [ngClass]="{ 'is-loading': cargando }" [disabled]="ctrl.dato.invalid || cargando"
                  *ngIf="!tieneid" (click)="ctrl.abrirModal('confirmarLiquidacion')">
                  <span class="icon fa-2x has-text-success">
                    <i class="icon-diskette"> </i>
                  </span>
                  <span class="tooltiptext">Guardar</span>
                </button>
                <span class="navbar-item"></span>
              </div>
            </nav>
          </div>
        </section>

        <div style="padding: 0em;">
          <!--
            cargar los catalogos que se requieran parametro 1 modelo donde se guarda el catalogo, parametro 2 ruta de la api
          -->
          <a id="catalogos" (click)="
              ctrl.cargarCatalogo(
                'catalogos_usos_cfdis',
                ctrl.CFDI_PATH + '/api/v1/catalogo-uso-cfdi'
              );
              ctrl.cargarCatalogo('bancos', 'banco');
              ctrl.cargarCatalogo('metodos_pagos', 'tipo-metodo-pago');
              ctrl.cargarCatalogo('formas_pagos', 'tipo-forma-pago');
              ctrl.cargarCatalogo('logos64', 'logos64', 'logo64');"></a>
          <a id="logo64" (click)="asignarLogos(ctrl.logos64); "></a>
          <h3 class="title has-background-primary" style="height: 33px;"><i class="icon-file"></i> Datos del pago</h3>
          <div class="notification is-warning" *ngIf="
              !caja_abierta &&
              ctrl.configuracion.sucursal.notificar_caja_cerrada
            ">
            ¡No se ha detectado ninguna caja abierta!
            <strong>Puede realizar el pago</strong>, Pero se recomienda que se
            abra la caja
            <a *ngIf="!tieneid" class="button is-small" routerLink="../../caja-operacion/nuevo">Abrir una caja</a>
            <a *ngIf="tieneid" class="button is-small" routerLink="../../../caja-operacion/nuevo">Abrir una caja</a>
          </div>

          <div class="card">
            <header class="card-header">
              <div class="card-header-title">

              </div>
              <a class="card-header-icon">
                <span class="icon fa-2x"> <i class="icon-money3"></i> </span>
              </a>
            </header>
            <div class="card-content" style="padding: 0px; height: 88.8vh; border-left: 1px solid #d5d5d5;">
              <div >
                <div class="content" >
                  <div >
                    <article class="media">
                      <div class="media-content">
                        <div style="display:flow-root">

                        </div>
                        <br>
                        <div class="columns">
                          <div class="column is-12">
                            <label>Forma de pago: </label>
                            <div class="select">
                              <select class="select" name="tipos_formas_pagos_id" formControlName="tipos_formas_pagos_id">
                                <option *ngFor="let val of ctrl.formas_pagos" value="{{val.id}}">{{ val.nombre }}</option>
                              </select>
                            </div>
                          </div>
                        </div>
                        <div class="columns">
                          <div class="column is-12">
                            <label>Cantidad: </label>

                            <p class="control has-icons-left has-icons-right" >
                              <input class="input has-text-centered is-warning" type="text" placeholder="Cantidad" formControlName="cantidad"  />
                            </p>
                          </div>
                        </div>
                      </div>
                    </article>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</form>


<div class="modal" id="confirmarLiquidacion">
  <div class="modal-background"></div>
  <div class="modal-card">
    <header class="modal-card-head">
      <p class="modal-card-title"><i class="fa fa-warning"></i> Alerta</p>
      <button class="delete" (click)="ctrl.cancelarModal('confirmarLiquidacion')"></button>
    </header>
    <section class="modal-card-body">
      <div class="content">
        <h1>¿Esta seguro de generar el pago?</h1>
        <p>Ya no se podra editar la información una vez guardada</p>
      </div>
    </section>
    <footer class="modal-card-foot">
      <a class="button is-success" (click)="enviar()" [ngClass]="{ 'is-loading': borrarCargando }">Continuar</a>
      <a class="button" (click)="ctrl.cancelarModal('confirmarLiquidacion')">Cerrar Ventana</a>
    </footer>
  </div>
</div>


<div id="banner" align="center" *ngIf="cargando || ctrl.cargarDatosCatalogo">
  <div class="bloquear-azul"></div>
  <span class="tag is-primary is-large " style="position: absolute; top: 45%; font-size: 2em; z-index: 999999999;  left: 45%;">
    <span class="icon"> <i class="icon-worldwide fa-spin"></i> </span> &nbsp;
    <span>Cargando...</span>
  </span>
</div>

<div class="modal" id="guardado_exito">
  <div class="modal-background"></div>
  <div class="modal-card">
    <header class="modal-card-head">
      <p class="modal-card-title"><i class="fa fa-success"></i> Guardado</p>
      <button class="delete" (click)="ctrl.cancelarModal('guardado_exito')"></button>
    </header>
    <section class="modal-card-body">
      <div class="content">
        <h1>¡Se ha guardado el pago!</h1>
        <p>
          Para generar la factura de click en la hoja gris a lado del boton guardar
        </p>
      </div>
    </section>
    <footer class="modal-card-foot">
      <a class="button" (click)="ctrl.cancelarModal('guardado_exito')">Ok</a>
    </footer>
  </div>
</div>


<!-- ////////////////////////////////////////////////////// Facturacion /////////////////-->
<div class="modal" id="verPdf">
  <div class="modal-background"></div>
  <div class="modal-card" style="width:80%">
    <header class="modal-card-head">
      <div class="modal-card-title">
        <nav class="level">
          <!-- Left side -->
          <div class="level-left">
            <div class="level-item">
              <p class="subtitle is-5">
                <strong>Facturación {{facturacion.Version}} </strong>
              </p>
            </div>
          </div>

          <!-- Right side -->
          <div class="level-right">
            <p class="level-item">
              <a class=" navbar-item tooltip" id="imprimir_pdf" (click)="ctrl.imprimeFactura(facturacion, logo)">
                <span class="icon fa-2x">
                  <i class="icon-printer2"></i>
                </span>
                <span class="tooltiptext is-hidden-touch">&nbsp; Imprimir</span>
              </a>

              <button class="navbar-item is-success tooltip" (click)="ctrl.abrirModal('confirmarTimbrar')" [disabled]="cargando"
                *ngIf="valido  && !ctrl.dato.get('facturas_id').value">
                <span class="icon fa-2x has-text-black">
                  <i class="fa fa-qrcode"></i>
                </span>
                <span class="tooltiptext is-hidden-touch">&nbsp; Timbrar</span>
              </button>

              <a class=" navbar-item"></a>
            </p>
          </div>
        </nav>
      </div>
      <button class="delete" (click)="ctrl.cancelarModal('verPdf')"></button>
    </header>
    <section class="modal-card-body" *ngIf="facturacion_inicio">

      <div class="box">
        <article class="media">
          <div class="media-content">
            <section class="hero is-primary">
              <div class="hero-body">
                <nav class="level">
                  <div class="columns">
                    <div class="column is-9">
                      Uso CFDI:
                      <div class="select" style="float:right">
                        <select class="select" [(ngModel)]="facturacion.Receptor.UsoCFDI" [ngModelOptions]="{standalone: true}">
                          <option *ngFor="let item of ctrl.catalogos_usos_cfdis" value="{{item.clave}}">{{item.nombre}}</option>
                        </select>
                      </div>
                    </div>
                    <div class="column is-6">
                      Impuestos:
                      <hr style="border: none; margin: 0.5rem 0; height: 0px;">
                      <div class="b-checkbox is-large" style="float:left">
                        <input id="seleccionar_iva" class="styled" type="checkbox" [(ngModel)]="seleccionar_iva">
                        <label for="seleccionar_iva">
                          {{seleccionar_iva ? 'Seleccionar productos con iva' : 'Todos los productos con iva'}}
                        </label>
                      </div>
                    </div>
                  </div>
                </nav>
              </div>
            </section>

            <div class="notification is-danger" *ngIf="error_timbre">
              ¡Ocurrio un error al intentar timbrar la factura!
              <strong>Por favor</strong>, intentelo de nuevo
            </div>
            <div class="notification is-danger" *ngIf="error_busqueda">
              ¡Ocurrio un error al intentar buscar!
              <strong>Por favor</strong>, intentelo de nuevo
            </div>
            <div class="notification is-black" *ngIf="sin_resultado != ''">
              ¡Mesaje del servidor!
              <strong>{{sin_resultado}}</strong>
            </div>
            <div *ngIf="errores.length > 0">
              <div class="notification is-danger" *ngFor="let msg of errores;">
                <font size="6pt">{{msg.codigo}}</font> {{msg.mensaje}}
                <strong>{{msg.fecha | formatoFecha}}</strong>
              </div>
            </div>
            <div class="is-fullwidth has-text-centered" *ngIf="cargando">
              <br>
              <span class="tag is-primary is-large ">
                <span class="icon">
                  <i class="icon-worldwide fa-spin"></i>
                </span> &nbsp;
                <span>Cargando...</span>
              </span>
              <br>
              <br>
            </div>
            <br>
            <div id="imprimir_factura">
              <article class="media">
                <div class="media-content">
                  <div>
                    <!-- emisor -->
                    <div class="columns">
                      <div class="column is-2">
                        <figure class="image is-1by1 figure-border logo">
                          <img [src]="ctrl.configuracion.sucursal.logo ? ctrl.API_PATH+'/adjunto/configuracion/'+ ctrl.configuracion.sucursal.logo : ctrl.configuracion.empresa.logo ? ctrl.API_PATH+'/adjunto/configuracion/'+ ctrl.configuracion.empresa.logo : './assets/yoursoft.png'">
                        </figure>
                      </div>

                      <div class="column is-6">
                        <div class="box">
                          <article class="media">
                            <div class="media-content">
                              <div class="content">
                                <p>
                                  <strong>Folio fiscal: </strong>
                                  {{facturacion.Complemento.TimbreFiscalDigital.UUID}}
                                </p>
                                <p>
                                  <strong>No. de serie del CSD: </strong>
                                  {{facturacion.NoCertificado}}
                                </p>
                                <p>
                                  <strong>No. de serie del certificado SAT: </strong>
                                  {{facturacion.Complemento.TimbreFiscalDigital.NoCertificadoSAT}}
                                </p>
                                <p>
                                  <strong>Fecha y hora de emisión: </strong>
                                  {{facturacion.Fecha }}
                                </p>
                                <p>
                                  <strong>Fecha y hora de certificación: </strong>
                                  {{facturacion.Complemento.TimbreFiscalDigital.FechaTimbrado}}
                                </p>
                              </div>
                            </div>
                          </article>
                        </div>
                      </div>

                      <div class="column is-4">
                        <div class="box">
                          <article class="media">
                            <div class="media-content">
                              <div class="content">
                                <p>
                                  <strong>Emisor: </strong>
                                  {{facturacion.Emisor.Nombre}}
                                </p>
                                <p>
                                  <strong>R.F.C.: </strong>
                                  {{facturacion.Emisor.Rfc}}
                                </p>
                                <p>
                                  <strong>Lugar de expedición: </strong>
                                  {{facturacion.LugarExpedicion}}
                                </p>
                                <p>
                                  <strong>Régimen fiscal: </strong>
                                  {{facturacion.Emisor.RegimenFiscal}}
                                </p>
                                <p>
                                  <strong>Tipo de comprobante: </strong>
                                  {{facturacion.TipoDeComprobante}}
                                </p>

                              </div>
                            </div>
                          </article>
                        </div>
                      </div>
                    </div>
                    <!-- datos del cliente -->
                    <div class="columns">
                      <div class="column is-8">
                        <div class="box">
                          <article class="media">
                            <div class="media-content">
                              <div class="content">
                                <p>
                                  <strong>Receptor:</strong>
                                  {{facturacion.Receptor.Nombre}}
                                </p>
                                <p>
                                  <strong>R.F.C.:</strong>
                                  {{facturacion.Receptor.Rfc}}
                                </p>
                              </div>
                            </div>
                          </article>
                        </div>
                      </div>
                      <div class="column is-4">
                        <div class="box">
                          <article class="media">
                            <div class="media-content">
                              <div class="content">
                                <p>
                                  <strong>Uso CFDI:</strong>
                                  {{facturacion.Receptor.UsoCFDI}}
                                </p>
                                <p>
                                  <strong>Folio y serie:</strong>
                                  {{facturacion.Folio}} {{facturacion.Serie}}
                                </p>
                              </div>
                            </div>
                          </article>
                        </div>
                      </div>
                    </div>


                    <!-- detalle de los articulos -->
                    <div class="columns">
                      <div class="column is-12">
                        <div class="box">
                          <article class="media">
                            <div class="media-content">
                              <div class="content">
                                <table class="table is-striped  is-fullwidth">
                                  <thead>
                                    <tr>
                                      <th>Cve prod/serv </th>
                                      <th>No. Identificacion </th>
                                      <th>Cantidad </th>
                                      <th>Unidad</th>
                                      <th>Descripción </th>
                                      <th>Precio </th>
                                      <th>Descuento </th>
                                      <th>Impuesto </th>
                                      <th>Importe </th>
                                      <th *ngIf="seleccionar_iva" class="novisible">IVA?</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr *ngFor="let concepto of facturacion.Conceptos.Concepto; let i = index">
                                      <td>{{concepto.ClaveProdServ}}</td>
                                      <td>{{concepto.NoIdentificacion}}</td>
                                      <td>{{concepto.Cantidad}}</td>
                                      <td>{{concepto.ClaveUnidad}} {{concepto.Unidad}}</td>
                                      <td>{{concepto.Descripcion}}</td>
                                      <td>{{concepto.ValorUnitario | currency:ctrl.configuracion.sucursal.moneda}} </td>
                                      <td>{{concepto.Descuento | currency:ctrl.configuracion.sucursal.moneda}}</td>
                                      <td>
                                        <span *ngIf="concepto.Impuestos">
                                          <small *ngIf="concepto.Impuestos.Traslados.length > 0">Traslados</small>
                                          <span *ngFor="let traslado of concepto.Impuestos.Traslados">
                                            <strong>{{traslado.Traslado.Impuesto}} ({{traslado.Traslado.TipoFactor
                                              == 'Tasa' ? traslado.Traslado.TasaOCuota
                                              * 100 : traslado.Traslado.TasaOCuota}}%):
                                            </strong>
                                            {{traslado.Traslado.Importe | currency:ctrl.configuracion.sucursal.moneda}}
                                          </span>
                                        </span>

                                        <span *ngIf="concepto.Impuestos">
                                          <small *ngIf="concepto.Impuestos.Retenciones.length > 0">Retenciones</small>
                                          <span *ngFor="let retencion of concepto.Impuestos.Retenciones">
                                            <strong>{{retencion.Retencion.Impuesto}} ({{retencion.Retencion.TipoFactor
                                              == 'Tasa' ? retencion.Retencion.TasaOCuota
                                              * 100 : retencion.Retencion.TasaOCuota}}%):</strong>
                                            {{retencion.Retencion.Importe |
                                            currency:ctrl.configuracion.sucursal.moneda}}
                                          </span>
                                        </span>
                                      </td>
                                      <td>{{concepto.Importe | currency:ctrl.configuracion.sucursal.moneda}}</td>
                                      <td class="novisible" *ngIf="seleccionar_iva">
                                        <div class="b-checkbox is-large">
                                          <input id="con_iva{{i}}" class="styled" type="checkbox" [(ngModel)]="concepto.iva"
                                            (click)="quita_poner_iva(concepto)" (checked)="concepto.iva ? true: false">
                                          <label for="con_iva{{i}}">

                                          </label>
                                        </div>
                                      </td>
                                    </tr>
                                  </tbody>

                                </table>
                              </div>
                            </div>
                          </article>
                        </div>
                      </div>
                    </div>
                    <!-- pago -->
                    <div class="columns">
                      <div class="column is-8">
                        <div class="box">
                          <article class="media">
                            <div class="media-content">
                              <div class="content">
                                <div>
                                  <strong>Total con letra</strong>
                                  {{facturacion.Total | numeroLetra:configuracion.sucursal.moneda}}
                                  <hr class="hr">
                                </div>
                                <div class="columns">
                                  <div class="column is-6">
                                    <p>
                                      <strong>Moneda:</strong>
                                      {{facturacion.Moneda}}
                                    </p>
                                    <p>
                                      <strong>Forma de pago:</strong>
                                      {{facturacion.FormaPago}}
                                    </p>
                                  </div>
                                  <div class="column is-6">
                                    <p>
                                      <strong>Método de pago:</strong>
                                      {{facturacion.MetodoPago}}
                                    </p>
                                    <p>
                                      <strong>Condiciones de pago:</strong>
                                      <span class="sellos_sat" style="word-wrap: break-word; font-size:9pt;">
                                        {{facturacion.CondicionesDePago}}
                                      </span>
                                    </p>
                                  </div>
                                </div>

                              </div>
                            </div>
                          </article>
                        </div>
                      </div>
                      <div class="column is-4">
                        <div class="box">
                          <article class="media">
                            <div class="media-content">
                              <div class="content">
                                <p>
                                  <strong>Subtotal:</strong>
                                  {{facturacion.SubTotal | currency:ctrl.configuracion.sucursal.moneda}}
                                </p>
                                <p>
                                  <strong>Descuento:</strong>
                                  {{facturacion.Descuento | currency:ctrl.configuracion.sucursal.moneda}}
                                </p>
                                <div class="impuestos_fac" *ngIf="facturacion.Impuestos">

                                  <small *ngIf="facturacion.Impuestos.Traslados.length > 0">Traslados</small>
                                  <p *ngFor="let traslado of facturacion.Impuestos.Traslados">
                                    <strong>{{traslado.Traslado.Impuesto}} ({{traslado.Traslado.TipoFactor
                                      == 'Tasa' ? traslado.Traslado.TasaOCuota * 100 :
                                      traslado.Traslado.TasaOCuota}}%):</strong>
                                    {{traslado.Traslado.Importe | currency:ctrl.configuracion.sucursal.moneda}}

                                  </p>
                                </div>
                                <div class="impuestos_fac" *ngIf="facturacion.Impuestos">
                                  <small *ngIf="facturacion.Impuestos.Retenciones.length > 0">Retenciones</small>
                                  <p *ngFor="let retencion of facturacion.Impuestos.Retenciones">
                                    <strong>{{retencion.Retencion.Impuesto}} ({{retencion.Retencion.TipoFactor
                                      == 'Tasa' ? retencion.Retencion.TasaOCuota * 100 :
                                      retencion.Retencion.TasaOCuota}}%):</strong>
                                    {{retencion.Retencion.Importe | currency:ctrl.configuracion.sucursal.moneda}}

                                  </p>
                                </div>
                                <p>
                                  <strong>Total:</strong>
                                  {{facturacion.Total | currency:ctrl.configuracion.sucursal.moneda}}
                                </p>
                              </div>
                            </div>
                          </article>
                        </div>
                      </div>
                    </div>

                    <!-- qy y sellos -->
                    <div class="columns">
                      <div class="column is-2">
                        <figure class="image is-1by1 figure-border">
                          <img [src]="'data:image/png;base64,' + facturacion.Complemento.TimbreFiscalDigital.qr" *ngIf="facturacion.Complemento.TimbreFiscalDigital.qr != ''">
                          <img src="assets/qr.png" *ngIf="facturacion.Complemento.TimbreFiscalDigital.qr == ''">
                        </figure>
                      </div>
                      <div class="column is-10">
                        <div class="box">
                          <article class="media">
                            <div class="media-content">
                              <div class="content sellos">
                                <div>
                                  <strong>Sello digital del CFDI:</strong>
                                  <br>
                                  <div class="sellos_sat" style="word-wrap: break-word; font-size:8.5pt;">
                                    {{facturacion.Complemento.TimbreFiscalDigital.SelloCFD}}
                                  </div>
                                </div>
                                <div>
                                  <strong>Sello digital del SAT:</strong>
                                  <br>
                                  <div class="sellos_sat" style="word-wrap: break-word; font-size:8.5pt;">
                                    {{facturacion.Complemento.TimbreFiscalDigital.SelloSAT}}
                                  </div>
                                </div>
                                <div>
                                  <strong>Cadena original del complemento de certificación del SAT:
                                  </strong>
                                  <br>
                                  <div class="sellos_sat" style="word-wrap: break-word; font-size:8.5pt;">
                                    {{facturacion.Complemento.TimbreFiscalDigital.CadenaOriginal}}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </article>
                        </div>
                      </div>
                    </div>
                    <p align="center">
                      <strong>Este documento es una representación impresa de un CFDI versión {{VERSION_CFDI}}</strong>
                    </p>
                  </div>
                </div>
              </article>
            </div>
          </div>
        </article>
      </div>
    </section>
    <footer class="modal-card-foot">
      <a class="button" (click)="ctrl.cancelarModal('verPdf')">Cancelar</a>
    </footer>
  </div>
</div>


<div class="modal" id="confirmarTimbrar">
  <div class="modal-background"></div>
  <div class="modal-card">
    <header class="modal-card-head">
      <p class="modal-card-title">
        <i class="fa fa-warning"></i> Confirmar</p>
      <button class="delete" (click)="ctrl.cancelarModal('confirmarTimbrar')"></button>
    </header>
    <section class="modal-card-body">
      <div class="content">
        <h1>¿Esta seguro de iniciar el proceso de timbrado?</h1>
        <p>Ya no se podra agregar más información a esta hoja</p>
      </div>
    </section>
    <footer class="modal-card-foot">
      <a class="button is-success" (click)="timbrar()">Continuar</a>
      <a class="button" (click)="ctrl.cancelarModal('confirmarTimbrar')">Cancelar</a>
    </footer>
  </div>
</div>
